export default __webpack_public_path__ + "static/media/face_3_38.f5e99aaf.png";